import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import useToast, { TOAST_TYPE } from '../../../hooks/useToast';
import ActionButton from '../../elements/action-button/ActionButton';

const StripeCardForm = ({ handleSubmit, handleClose }) => {
  const { t } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();
  const { showToast } = useToast();

  const handleFormSubmit = async () => {
    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);
    const { error, token } = await stripe.createToken(cardElement);

    if (error) {
      showToast(TOAST_TYPE.ERROR, error.message);
    } else {
      await handleSubmit(token);
    }
  };

  return (
    <>
      <form autoComplete="off">
        <Card sx={{ p: 2 }} variant="outlined">
          <CardElement />
        </Card>
        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}
        >
          <Button variant="text" type="reset" onClick={handleClose}>
            {t('cancel', { ns: 'buttons' })}
          </Button>
          <ActionButton clickAction={handleFormSubmit} disabled={!stripe}>
            {t('saveCard', { ns: 'buttons' })}
          </ActionButton>
        </Box>
      </form>
    </>
  );
};

StripeCardForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func,
};

export default StripeCardForm;
